import Image from 'next/image';

export default function AsideLayout(props) {
    const { className, location, aside, heroImage, prev, next, children, heroImageSize = 'large'} = props;

    let heroImageContent, locationContent, leadingContent, nextContent, prevContent;

    if (location) {
        locationContent = (
            <div className="bg-grey">
                <div className="container text-center md:text-left py-20">
                    { location ?? "" }
                </div>
            </div>
        );
    }

    if (heroImage) {

        let heroImageClassName = (heroImageSize === 'large' ? 'h-[290px] md:h-[380px] lg:h-[496px] xl:h-[512px]' : 'h-[290px] md:h-[380px] lg:h-[448px]')
        heroImageContent = (
            <>
                <div className={`hidden sm:block bg-white ${heroImageClassName} relative`}>
                    <Image
                        src={ heroImage }
                        alt="Hero Image"
                        layout="fill"
                        objectFit="cover"
                        quality="100"
                        priority={ true }
                        placeholder="blur"
                    />
                </div>
                <div className="sm:hidden bg-white relative">
                    <Image
                        src={ heroImage }
                        alt="Hero Image"
                        layout="responsive"
                        objectFit="fill"
                        quality="100"
                        priority={ true }
                        placeholder="blur"
                    />
                </div>
            </>
        );
    }

    if (prev) {
        prevContent = (
            <div className="flex-1">{ prev }</div>
        );
    }

    if (next) {
        nextContent = (
            <div className="flex-1 text-right">{ next }</div>
        );
    }

    if (prev || next) {
        leadingContent = (
            <div className="bg-white">
                <div className="container flex pt-40 pb-80 gap-20">
                    { prevContent }
                    { nextContent }
                </div>
            </div>
        );
    }

    return (
        <div className={ (heroImageContent ? "pt-[102px] lg:pt-[124px]" : "") + ( className ? " " + className : "" ) }>
            { heroImageContent }
            { locationContent }
            <div className="bg-white">
                <div className="container lg:grid lg:grid-cols-4 py-60 gap-40">
                    <aside className="hidden lg:block">
                        { aside }
                    </aside>
                    <section className="lg:col-span-3">
                        { children }
                    </section>
                </div>
            </div>
            { leadingContent }
        </div>
    )
}